import React from 'react';
import localization from 'assets/localization/localization';
import './cardSection.css'
const CardSection = ({ children, title, status, remove, removeIt }) => {
  return (
    <div className="col-md-6 col-sm-12 col-xs-12">
<div className="card">
  <div className="card-header">
  {title} {status && (
           <div className="panel_Design">
          <span
            className={`status-td ${status === 'In Progress'
                ? `warm`
                : status === 'Not Started'
                  ? 'cold'
                  : status === 'Completed'
                    ? 'completed'
                    : ''
              }`}
          >
            {status}
          </span>
          </div>
         
        )}
        {remove && (
          <a
            className="field-remove"
            onClick={() => {
              removeIt(true);
            }}
          >
            {localization.remove}
          </a>
        )}
  </div>
  <div className="card-body">
    {children}
  </div>
</div>
</div>

  //  <div className="panel-first">
  //   <div className="panel-list panel-list-align">
       
  //   <div className="panel-card ">
    
  //     <div className="panel-heading">
     
  //       {title}
  //       {status && (
  //          <div className="panel_Design">
  //         <span
  //           className={`status-td ${status === 'In Progress'
  //               ? `warm`
  //               : status === 'Not Started'
  //                 ? 'cold'
  //                 : status === 'Completed'
  //                   ? 'completed'
  //                   : ''
  //             }`}
  //         >
  //           {status}
  //         </span>
  //         </div>
         
  //       )}
  //       {remove && (
  //         <a
  //           className="field-remove"
  //           onClick={() => {
  //             removeIt(true);
  //           }}
  //         >
  //           {localization.remove}
  //         </a>
  //       )}
  //        </div>
    
      
  //     <div className="panel-body panel_grid panel_N">{children}</div>
  //   </div>
   
  //    </div>
  //    </div>
  );
};

export default CardSection;
